import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/LineAndBar/settings/DataTab';
import { ViewTab } from 'modules/visualisations/LineAndBar/settings/ViewTab';

export const LineAndBarMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
